import { Controller } from "@hotwired/stimulus"
import { TurboBeforeFetchRequestEvent } from "@hotwired/turbo"
import Confirmation from "../../confirmation"

export default class ContactsController extends Controller {
  getContactName(el: EventTarget | null): string | undefined {
    if (el instanceof HTMLElement) {
      return el.closest("tr")?.dataset.contactName
    }
  }

  async confirmRemove(event: TurboBeforeFetchRequestEvent) {
    event.preventDefault()

    const contactName = this.getContactName(event.target)

    if (await Confirmation.confirmRemove(contactName || "this contact")) {
      event.detail.resume(null)
    }
  }
}
